module.exports = __webpack_public_path__ + "img/thumbnail_Gharial_m_albino.3556f125.png";